module.exports = __webpack_public_path__ + "mainassets/img/form_1.611af396.svg";